import './App.css'
import './index.css'
import { store } from './store/store'
import { Provider } from 'react-redux'
import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from 'react-router-dom'
import Home from './pages/home'
import Login from './pages/login'
import { useLazyGetUserQuery } from './reducers/apiSlice'
import CreateGame from './pages/create-game'
import GamePage from './pages/game'
import JoinGameRedirect from './pages/join-game'
import { Outlet } from 'react-router-dom'
import Register from './pages/register'
import Lobby from './pages/lobby/lobby'
import PassportPage from './pages/passport'
import Host from './pages/host'
import AdminGames from './pages/admin-games'
import { ToastProvider } from '@radix-ui/react-toast'
import Toast from './components/ui/toast'
import { setIsLoggedIn, setRefreshToken, setAccessToken } from './reducers/loginReducer'
import { useEffect } from 'react'
import HeaderBar from './components/HeaderBar/HeaderBar'
import { LoginModalProvider } from './components/Modals/loginModalContext'
/* UI-DESIGN: pages for the header's Mysteries (/mysteries, formerly Cases at
   /games), Open Cases (/open-cases), and How it works (/about) links */
import Mysteries from './pages/mysteries'
import OpenCases from './pages/open-cases'
import About from './pages/about'
/* UI-DESIGN: /preview is the design QA dashboard (sample-data preview
   URLs + live theme switcher). Frontend-only — remove when shipped. */
import Preview from './pages/preview'
/* BRAND-MOCK: /brand is a throwaway identity mock ("glamorous conspiratorial
   dinner party" direction). All its brand tokens are scoped to the page, so
   nothing global is affected. Delete src/pages/brand, this import, its route,
   and the Bodoni link in index.html to fully remove. */
import BrandMock from './pages/brand'

const RootLayout = () => {
  
  const [triggerGetUser] = useLazyGetUserQuery();

  useEffect(() => {
    const accessToken = localStorage.getItem("access_token");
    const refreshToken = localStorage.getItem("refresh_token");
    if (accessToken) {
      store.dispatch(setIsLoggedIn(true));
      store.dispatch(setAccessToken(accessToken));
      store.dispatch(setRefreshToken(refreshToken));

      triggerGetUser(undefined).then((res: any) => {
        console.log(res);
      }).catch((err: any) => {
        console.log(err);
      })
    }
  }, []);
  
  return (
    <LoginModalProvider>
      <div className="min-w-screen min-h-screen p-4 bg-background">
        <HeaderBar />
        <Outlet />
      </div>
    </LoginModalProvider>
  )
}

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<RootLayout />}>
      <Route index element={<Home />} />
      <Route path="login" element={<Login />} />
      <Route path="create-game" element={<CreateGame />} />
      <Route path="game/:gameId" element={<GamePage />} />
      <Route path="join/:gameId" element={<JoinGameRedirect />} />
      <Route path="register" element={<Register />} />
      <Route path="lobby" element={<Lobby />} />
      <Route path="passport" element={<PassportPage />} />
      <Route path="host" element={<Host />} />
      <Route path="admin-games" element={<AdminGames />} />
      {/* UI-DESIGN: routes for the header nav links (see import note above);
          /games stays as an alias so old links to the catalog keep working */}
      <Route path="mysteries" element={<Mysteries />} />
      <Route path="games" element={<Mysteries />} />
      <Route path="open-cases" element={<OpenCases />} />
      <Route path="about" element={<About />} />
      {/* UI-DESIGN: design QA dashboard — preview URLs + theme switcher */}
      <Route path="preview" element={<Preview />} />
      {/* BRAND-MOCK: throwaway identity mock — delete this line to remove */}
      <Route path="brand" element={<BrandMock />} />
    </Route>
  )
)

function App() {
  return (
      <Provider store={store}>
          <ToastProvider>
          <Toast/>
          <RouterProvider router={router} />
          </ToastProvider>
      </Provider>
  )
}

export default App
